import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements AfterViewInit, OnInit {
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    @ViewChild('contenedorMovil') contentMovil: ElementRef;
    public faqs = [
        {
            question: '¿Cómo enviar un documento a firma con FAD®?',
            description: 'Aquí te decimos como <a href="https://www.youtube.com/watch?v=gzmHZb8MFtU" target="_blank">Da clic aquí.</a>'
        },
        {
            question: '¿Cómo firmar un documento con FAD®?',
            description: 'Aquí te decimos como <a href="https://www.youtube.com/watch?v=jq5UIEzi7G4" target="_blank">Da clic aquí.</a>'
        },
        {
            question: '¿En dónde se almacenan los documentos firmados con FAD®?',
            description: 'FAD® no almacena ningún documento firmado, el usuario es responsable de almacenar los archivos generados en el proceso de firma.'
        },
        {
            question: '¿La firma de documentos a través de FAD® tiene la misma validez que la firma en papel?',
            description: 'Firma para afiliación móvil de comercios con video firma, video de aceptación del acuerdo, geolocalización y constancia de conservación avalada por las autoridades.'
        },
        {
            question: '¿Qué documentos puedo firmar con FAD®?',
            description: 'Con FAD® puedes firmar solicitudes, contratos, pagarés, recibos, órdenes y mucho más. En realidad, FAD® permite firmar cualquier tipo de documento que requiera certeza jurídica en ambientes móviles y digitales. Para más información visita:<br> <a target="_blank"  href="https://blog.firmaautografa.com/los-mil-y-un-usos-de-la-firma-autografa-digital-fad"> www.firmaautografa.com/casos-uso </a>'
        },
        {
            question: '¿Necesito internet para utilizar FAD®?',
            description: 'Es necesaria la conexión a Internet para poder obtener el documento a firmar, una vez estando dentro de la aplicación podrás firmar sin conexión y tu firma en el documento será enviada en cuanto tu conexión a Internet sea restablecida.'
        },
        {
            question: '¿Puedo firmar de manera offline (sin Internet)?',
            description: 'Sí, una vez teniendo el documento a firmar dentro de la app móvil de FAD® podrás firmar sin Internet. Por ejemplo, puedes firmar mientras te encuentres viajando en un avión y enviar los documentos firmados una vez que llegues a tu destino, una vez que se restableció tu conexión.'
        },
        {
            question: '¿Pueden firmar en el mismo smartphone todas las personas involucradas en el documento?',
            description: 'Sí, con FAD® pueden firmar todos los firmantes en el mismo dispositivo.'
        },
        {
            question: '¿Los involucrados pueden firmar un documento en diferentes smartphones?',
            description: 'Sí, con FAD® los involucrados pueden firmar desde su smartphone, sin importar que se encuentren en diferentes puntos geográficos.'
        },
        {
            question: '¿Es seguro firmar utilizando FAD®?',
            description: 'FAD® es más segura que el papel gracias a los distintos elementos tecnológicos aplicados en el documento y en la solución (elementos multimedia de identificación, códigos de verificación y constancia, cifrado de la información, etc.). Para más información visita: <a target="_blank"  href="https://www.firmaautografa.com/seguridad/"> www.firmaautografa.com/seguridad </a>'
        },
        {
            question: '¿Cuáles son los modelos de compra para adquirir FAD®?',
            description: 'Con FAD® puedes pagar por firma de documento o por un plan de renta mensual con el cual podrás firmar ilimitadamente. Para más información, por favor ponte en contacto con nosotros en: <a target="_blank"  href="https://www.firmaautografa.com/contacto/"> www.firmaautografa.com/contacto </span>'
        },
        {
            question: '¿Cómo descargo la app móvil de FAD®?',
            description: 'Al terminar de configurar el documento a firmar, se manda una liga por SMS para la descarga de la app móvil de FAD®.'
        },
        {
            question: '¿El documento queda guardado en el smartphone después de firmarlo?',
            description: 'La base de datos es eliminada del dispositivo sin dejar ningún rastro.'
        },
        {
            question: '¿El documento puede ser modificado después de haber sido firmado y enviado (al / los) firmante(s) durante el proceso de firma?',
            description: 'No, FAD® utiliza varios mecanismos de seguridad, empleando una comunicación segura mediante el uso de TLS, enviando la información cifrada y con un hash de verificación de autenticidad.'
        },
        {
            question: '¿Para qué sirve la Constancia de conservación?',
            description: 'Los documentos firmados con FAD® son almacenados en nuestros servidores de manera TEMPORAL – 30 días después de ser firmados-, y al mismo tiempo los depositamos en los repositorios que hayas destinado para ello. <br><br> Evidencia legal de integridad e inalterabilidad sobre un documento en caso de controversia. <br><br>  Cumplimiento de alteraciones legales. <br><br>  El tiempo exacto en que se generó un documento electrónico.'
        },
        {
            question: '¿Cómo estoy seguro que la operación de la firma no puede ser alterada y/o modificada?',
            description: ' FAD® brinda un conjunto irrefutable de evidencias a través de una Huella de Auditoría compuesta por 13 elementos, entre algunas se encuentran:<br><br>Autógrafo manuscrito del firmante.<br>  Video que graba la acción autógrafa del firmante y a la persona firmando de forma simultánea.<br>  Video de reconocimiento del compromiso adquirido por el firmante.<br><br> Para más información visita: <a target="_blank"  href="https://www.firmaautografa.com/huella-auditoria">https://www.firmaautografa.com/huella-de-auditoria/</a>'
        },
        {
            question: '¿Cuáles son las principales funcionalidades del sistema?',
            description: 'Con FAD® puedes enlazar tu repositorio o sistema de gestión de documentos y configurar las áreas en donde firmarán los involucrados, posteriormente podrás enviarles por SMS el link para descargar la app móvil en tiendas e instalarla, así como también un código QR o liga que contendrá el documento a firmar.'
        },
        {
            question: 'En caso de tener algún detalle con la operación de FAD®, ¿Cuento con soporte?',
            description: 'Sí, contarás con soporte vía correo electrónico, con respuesta en menos de 24 hrs.'
        },
        {
            question: '¿Qué hay acerca de las actualizaciones en FAD® después de ser comprado?',
            description: 'Contarás con todas las actualizaciones que nuestro equipo de desarrollo seguirá implementando para la mejora constante de FAD®.'
        }
    ];

    constructor(
        private deviceService: DeviceDetectorService,
        @Inject(PLATFORM_ID) private platformId: any,
        @Inject(DOCUMENT) private document: any
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        window.scrollTo(0, 0);
    }

    ngAfterViewInit(): void {
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {

            const ancla = sessionStorage.getItem('ancla');
            sessionStorage.removeItem('ancla');
            console.log(ancla)
            const scrollTo = ancla ? ancla : 'inicio';
        
            // Verificar si el elemento con el ID existe en el DOM
            const targetElement = this.document.getElementById(scrollTo);
              console.log(targetElement)
            if (targetElement) {
              setTimeout(() => {
                targetElement.scrollIntoView({
                  behavior: "instant",
                  block: "start",
                  inline: "nearest"
                });
              }, 300);
            }
          }
    }

}
